import { useState, useEffect } from "react";
import {
    Box,
    Flex,
    Input,
    InputGroup,
    Button,
    Avatar,
    Text,
    HStack,
    VStack,
    Separator,
} from "@chakra-ui/react";
import {
    useSelector,
    useDispatch
} from "react-redux";
import {
    useNavigate,
} from "react-router-dom";
import {
    Search,
    Bell,
} from "lucide-react";
import NotificationModal from "../views/Notifications/NotificationModal";
import { fetchMyDriverPartnerAction } from "../state/actions/driverPartnerActions";
import ActivityToast from "./ActivityToast";
import { toaster } from "./toaster";
import routes from "../routes";

const TopBar = () => {
        const dispatch =
    useDispatch();
    const navigate =
    useNavigate();
    const [
    isNotificationOpen,
    setNotificationOpen,
] = useState(false);
    const {
    driverPartner,
} = useSelector(
    (state) =>
        state.driverPartner
);

    useEffect(() => {
    dispatch(
        fetchMyDriverPartnerAction()
    );
}, [dispatch]);
const {
    notifications = [],
} = useSelector(
    (state) =>
        state.notifications
);

const hasUnreadNotifications =
    notifications.some(
        notification =>
            notification.read_status !==
            "Read"
    );

const user =
    driverPartner?.user;

const fullName =
    [
        user?.first_name,
        user?.middle_name,
        user?.last_name,
    ]
        .filter(
            Boolean
        )
        .join(" ");

const displayName =
    fullName.trim()
        ? fullName
        : user?.username ||
          "Driver Partner";

const initials =
    displayName
        .split(" ")
        .map(
            (name) =>
                name[0]
        )
        .join("")
        .slice(0, 2)
        .toUpperCase();
    const getProfileImage = (
    driverPartner
) => {
    const doc =
        driverPartner?.documents?.find(
            (d) =>
                d.document_type ===
                "Profile Image"
        );

    if (!doc)
        return null;

    const API_URL =
        process.env
            .REACT_APP_API_BASE_URL?.replace(
                /\/$/,
                ""
            );

    return `${API_URL}/${doc.file_path.replace(
        /^\//,
        ""
    )}`;
};
    const profileImage =
    getProfileImage(
        driverPartner
    );

    const handleShareReferral =
    async () => {
        const referralLink =
            driverPartner?.partner_referral_link;

        const referralCode =
            driverPartner?.partner_referral_code;

        if (
            referralLink &&
            navigator.share
        ) {
            try {
                await navigator.share(
                    {
                        title:
                            "Join Mogoma Driver",
                        text: `Join Mogoma using my referral link or referral code ${referralCode}`,
                        url: referralLink,
                    }
                );

                return;
            } catch (
                error
            ) {
                console.log(
                    error
                );
            }
        }

        const valueToCopy =
            referralLink ||
            referralCode;

        if (
            valueToCopy
        ) {
            await navigator.clipboard.writeText(
                valueToCopy
            );

           toaster.create({
    render: () => (
        <ActivityToast
            type="success"
            title={
                referralLink
                    ? "Referral Link Copied"
                    : "Referral Code Copied"
            }
            description={
                referralLink
                    ? "Your referral link has been copied to the clipboard."
                    : "Your referral code has been copied to the clipboard."
            }
            timestamp="Just now"
        />
    ),
});
        }
    };
    return (
            <>

        <Flex
            h={{
                base: "64px",
                md: "72px",
            }}
            px={{
                base: 4,
                md: 8,
            }}
            bg="white"
            borderBottom="1px solid"
            borderColor="gray.200"
            align="center"
            gap={4}
        >
            {/* Left */}

          

            {/* Mobile Title */}

         

            {/* Right */}

            <HStack
                ml="auto"
                gap={{
                    base: 3,
                    md: 5,
                }}
            >
                <Button
                    display={{
                        base: "none",
                        lg: "flex",
                    }}
                    bg="#2453FF"
                    color="white"
                    borderRadius="full"
                    px={8}
                    _hover={{
                        bg: "#1E46D8",
                    }}
                    onClick={
                        handleShareReferral
                    }
                >
                    Share Referral Code
                </Button>

             

               <Box
                position="relative"
                cursor="pointer"
                color="gray.600"
                _hover={{
                    color: "#2453FF",
                }}
                onClick={() =>
                    setNotificationOpen(
                        true
                    )
                }
            >
                    <Bell size={20} />

                    {hasUnreadNotifications && (
                    <Box
                        position="absolute"
                        top="-2px"
                        right="-2px"
                        w="8px"
                        h="8px"
                        borderRadius="full"
                        bg="red.500"
                    />
                    )}
                </Box>

                <Separator
                    display={{
                        base: "none",
                        md: "block",
                    }}
                    orientation="vertical"
                    h="40px"
                />

                <HStack 
                gap={3}
                cursor="pointer"
                borderRadius="12px"
                px={2}
                py={1}
                transition="all .2s"
                _hover={{
                    bg: "gray.50",
                }}
                onClick={() =>
                    navigate(
                        routes.settings
                    )
                }
                >
                    <VStack
                        display={{
                            base: "none",
                            md: "flex",
                        }}
                        gap={0}
                        align="flex-end"
                    >
                      <Text
                            fontWeight="600"
                            color="#071D54"
                            lineHeight="1"
                        >
                            {displayName}
                        </Text>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                        >
                            {
                                driverPartner?.partner_referral_code
                            }
                        </Text>
                     </VStack>

                  <Avatar.Root
                    size="md"
                    bg="#2453FF"
                    color="white"
                >
                    <Avatar.Image
                        src={profileImage}
                    />

                    <Avatar.Fallback
                        bg="transparent"
                        fontWeight="700"
                    >
                        {initials}
                    </Avatar.Fallback>
                </Avatar.Root>
                </HStack>
            </HStack>
        </Flex>
         <NotificationModal
            isOpen={
                isNotificationOpen
            }
            onClose={() =>
                setNotificationOpen(
                    false
                )
            }
        />
    </>
    );
};

export default TopBar;